import { ShareTargetFragment } from 'services/apollo/fragments/coreFragments';
import gql from 'graphql-tag';

export const SearchFeedQuery = gql`
  query getSearchFeed($cursor: String!, $searchString: String!, $includeGroups: Boolean!) {
    me {
      organization {
        id
        name
        type
      }
      search(query: $searchString, first: 20, cursor: $cursor) {
        searchTerm
        nodes {
          ... on Node {
            id
            title
            baseUrl
            url
            modified
            created
            isIntegrationConnected
            integrationType
            category
            owners {
              id
              name
              email
              avatarUrl
            }
            accessorInfo(includeGroups: $includeGroups) {
              accessors {
                ... on Group {
                  id
                  emoji
                  groupName: name
                }
                ... on Person {
                  id
                  name
                  email
                  avatarUrl
                }
              }
              pageInfo {
                endCursor
                hasNextPage
                total
              }
            }
            ...shareTargetResults @include(if: $includeGroups)
            sharingEnabled
            __typename
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          total
        }
      }
    }
  }
  ${ShareTargetFragment}
`;
